import React from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import PitchDeckRequestForm from './PitchDeckRequestForm';

interface PitchDeckModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const PitchDeckModal = ({ open, onOpenChange }: PitchDeckModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="p-0 border-0 bg-transparent max-w-md w-full h-auto">
        <div className="rounded-lg overflow-hidden">
          <PitchDeckRequestForm onClose={() => onOpenChange(false)} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PitchDeckModal;
